export function formatDate(inputDate) {
  const date = new Date(inputDate);

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const formattedMonth = months[monthIndex];

  const formattedDay = day < 10 ? `0${day}` : day;

  return `${formattedMonth} ${formattedDay}, ${year}`;
}
